import "./PaymentView.css";

import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import React, { useState } from "react";

import termsPDF from "../../../assets/Consumerterms.pdf";
import { useNavigate } from "react-router-dom";

function PaymentPage({
  selectedPlan,
  onClosePress,
  selectedCountry,
  vatAmount,
  vatRate,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [termsAccepted, setTermsAccepted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements || !termsAccepted) {
      return;
    }

    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: "https://eurointelligence.com",
      },
    });

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      alert(`Payment Failed!! \n ${result.error.message}`);
    } else {
      alert("Payment Successfull!!");
      navigate("/");
    }
  };

  const openTermsPDF = () => {
    window.open(termsPDF, "_blank");
  };

  return (
    <div className="payment-page-main-container">
      <div
        style={{
          fontSize: 24,
          color: "#161616",
          fontFamily: "Nunito Sans",
          fontWeight: "700",
          marginBottom: 20,
        }}
      >
        {selectedPlan.name} ({selectedPlan.currencySymbol}
        {selectedPlan.price} + {selectedPlan.currencySymbol}
        {vatAmount.toFixed(2)}({vatRate}% VAT))
      </div>
      <PaymentElement />
      <div className="terms-conditions-container">
        <label>
          <input
            type="checkbox"
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
            required
          />
          I accept the{" "}
          <span
            className="terms-link"
            onClick={openTermsPDF}
            style={{
              color: "#007bff",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Terms and Conditions
          </span>
        </label>
      </div>
      <div className="payment-fail-text">
        If you experience any issues,{" "}
        <a href="mailto:subscriptions@eurointelligence.com">contact us</a>
      </div>
      <button
        className="payment-page-pay-btn"
        disabled={!stripe || !termsAccepted}
        onClick={handleSubmit}
      >
        Pay now
      </button>
      <button className="payment-page-cancel-btn" onClick={onClosePress}>
        Cancel
      </button>
    </div>
  );
}

export default PaymentPage;
